export const ENDPOINTS = {
  order: () => `/billing/order`,
  detail: (id) => `/billing/order/${id}`,
  payment: (id) => `/billing/order/${id}/checkout`,
  paid: (id) => `/billing/order/${id}/paid-order`
};
